import React, { useRef } from 'react'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    ValidatorFormPadrao,
} from '../../../business-components/Form/Form'

import {
    GridContainer,
} from '../../../business-components/Grid/Grid'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import formList from '../../../business-rules/List/formList'

import {
    inicializaEstudo,
    processaCalculoEstudo
} from '../estudo-form/EstudoServiceCalculo'

import {
    processaCenariosDefaultJsonUsuario,
} from '../estudo-parametros/EstudoServiceCenarios'

import {
    EstudoFormCenarios
 } from '../estudo-parametros/EstudoFormCenarios'

import {
    CustomizedDialogsPopupConfiguracaoSimulacaoFinanceira,
    CustomizedDialogsPopupSelecionarCenarios,
} from './SimulacaoFinanceiraComp'

import SimulacaoFinanceiraFormParametros from './SimulacaoFinanceiraFormParametros'

import SimulacaoFinanceiraFormHipotesesFinanceiras from './SimulacaoFinanceiraFormHipotesesFinanceiras'



const SimulacaoFinanceiraForm = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue, handleSubmitAutomatico,
    vars}) => {
        
    const estudo = useRef(null)

    //const [reexibir, setReexibir] = useState(1)



    useSingleton(async () => {

        estudo.current = inicializaEstudo(/*vars.jsonConfiguracao*/)

        processaCenariosDefaultJsonUsuario(values, vars.jsonUsuario, vars.jsonUsuarioAdmin)
    })
    

    
    processaCalculoEstudo(values, handleSubmitAutomatico, estudo, false, true/*false*/,
        HARDCODE.origemCalculoEstudoPrimeiraReuniaoPlanilha, /*true*/false, vars.jsonConfiguracao, false)



    const linhaFormList = pesquisaList(formList, values.idFormList)



    return (
        //reexibir
        //    ?
                <DivForm>
                    <EstudoFormCenarios
                        values={values}
                        handleChange={handleChange}
                        handleSubmit={handleSubmit}
                        setFieldValue={setFieldValue}
                        simulacaoFinanceira={true}
                    />
                    
                    <ValidatorFormPadrao
                        onSubmit={handleSubmit}
                        onError={
                            () => null
                        }
                    >
                        <GridContainer>
                            <SimulacaoFinanceiraFormParametros
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                handleChange={handleChange}
                                handleSubmit={handleSubmit}
                                setFieldValue={setFieldValue}
                                handleSubmitAutomatico={handleSubmitAutomatico}
                                estudo={estudo}
                                vars={vars}
                                popup={false}
                                //reexibir={reexibir}
                                //setReexibir={setReexibir}
                            />
                        
                            <SimulacaoFinanceiraFormHipotesesFinanceiras
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                handleChange={handleChange}
                                //handleSubmit={handleSubmit}
                                setFieldValue={setFieldValue}
                                handleSubmitAutomatico={handleSubmitAutomatico}
                                estudo={estudo}
                                vars={vars}
                                linhaFormList={linhaFormList}
                                popup={false}
                            />

                            <CustomizedDialogsPopupConfiguracaoSimulacaoFinanceira
                                values={values}
                                handleChange={handleChange}
                                handleSubmit={handleSubmit}
                                setFieldValue={setFieldValue}
                            />

                            <CustomizedDialogsPopupSelecionarCenarios
                                variaveisGlobais={variaveisGlobais}
                                values={values}
                                handleChange={handleChange}
                                handleSubmit={handleSubmit}
                                setFieldValue={setFieldValue}
                                handleSubmitAutomatico={handleSubmitAutomatico}
                                estudo={estudo}
                                linhaTipoLicenca={vars.linhaTipoLicenca}
                                jsonConfiguracao={vars.jsonConfiguracao}
                                jsonPagina={vars.jsonPagina}
                                jsonUsuario={vars.jsonUsuario}
                                jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                            />
                        </GridContainer>
                    </ValidatorFormPadrao>
                </DivForm>
            //:
            //    ''
    )
}

export default SimulacaoFinanceiraForm